import { MenuItem } from "./MenuItem";
import { MenuItemTranslation } from "./Translation";

export interface DailyCount {
    date: string; // YYYY-MM-DD
    count: string;
}

export interface DailyScreenViews {
    last7days: DailyCount[];
    last30days: DailyCount[];
}

export interface MenuItemClick {
    item_id: string;
    item: MenuItem;
    count: string;
}

export interface MenuItemClicks {
    last7days: MenuItemClick[];
    last30days: MenuItemClick[];
}

export interface TrendSummary {
    likes: number;
    dislikes: number;
}

export interface MenuItemStats {
    menuItemId: number;
    translations: MenuItemTranslation[];
    likeCount: number;
    dislikeCount: number;
    trend7: TrendSummary;
    trend30: TrendSummary;
}

export function parseMenuItemStats(raw: any[]): MenuItemStats[] {
    return raw.map((item): MenuItemStats => ({
        menuItemId: Number(item.menuItemId),
        translations: item.translations ?? [],
        likeCount: Number(item.likeCount),
        dislikeCount: Number(item.dislikeCount),
        trend7: {
            likes: Number(item.trend7?.likes || 0),
            dislikes: Number(item.trend7?.dislikes || 0),
        },
        trend30: {
            likes: Number(item.trend30?.likes || 0),
            dislikes: Number(item.trend30?.dislikes || 0),
        },
    }));
}